import presetSelectTemplate from '../../../../../Template/config/components/selection/PresetSelect'

const presetSelect = {
  ...presetSelectTemplate,
  hasNormsTab: false,
}

export default presetSelect
export { presetSelect }



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryCovid/config/components/selection/PresetSelect/index.js